import React,{useEffect, useState} from 'react';
import {
    Typography,
    Box,
    Container
} from '@mui/material';
import { getArtworksByEventID } from '../../../../services/submissionService';
import { useLocation } from 'react-router-dom';
import ArtworksComponent from '../Components/ArtworksComponent';
import BackHeader from '../Components/BackHeader';

const EventDetail = () => {
    const [artworks,setArtworks] = useState([]);
    const [loading, setLoading] = useState(true);
    const { state } = useLocation();
    const event = state?.event;

    useEffect(() => {
        const loadEventsById = async () => {
            setLoading(true)
            try {
              const data = await getArtworksByEventID(event.id); 
              setArtworks(data)
              setLoading(false)
              console.log("artworks by eventId: ", data);
            } catch (error) {
              setLoading(false)
              console.error("Failed to load artwork", error);
            }
          };
        if (event)
            loadEventsById();
      }, [event]);
    if (loading) {
        return (
            <Container>
                <Typography variant="body1">Loading...</Typography>
            </Container>
        );
    }
    return (
        <Box>
          <BackHeader/>
            {/* Event Title and Description */}
            <Typography variant="h4" gutterBottom sx={{ fontFamily: 'basic-sans' }}>
                {event?.name}
            </Typography>

            <ArtworksComponent artworks={artworks} />
        </Box>
    );
};

export default EventDetail;
